li[role="option"] {
    padding: var(--uui-extra-small-spacing);
  }